// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {buildNumber} from '../../../../shared/services/build-number';

const AmountOfUseHistoryPanelTitle = props =>
    <span className='amount-of-use-history-title'>
        <FormattedMessage
            id='AMOUNT_OF_USE_HISTORY_WITH_COUNT'
            values={{
                count: buildNumber(props.count)
            }}
        />
    </span>;

AmountOfUseHistoryPanelTitle.displayName = 'AmountOfUseHistoryPanelTitle';
AmountOfUseHistoryPanelTitle.propTypes = {
    count: PropTypes.number
};

export default AmountOfUseHistoryPanelTitle;



// WEBPACK FOOTER //
// ./src/product/details/components/amount-of-use-history-panel/amount-of-use-history-panel-title.js